var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVr1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 425.36 274.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        mix-blend-mode: multiply;\n        opacity: .4;\n      }\n\n      .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-14 {\n        fill: #e47272;\n      }\n\n      .cls-15 {\n        fill: #fffffd;\n      }\n\n      .cls-16 {\n        fill: #9bc3ea;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-19 {\n        fill: #e6bc7a;\n      }\n\n      .cls-20 {\n        fill: #210042;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-24 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-25 {\n        fill: #d9dade;\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-32 {\n        fill: #3a6885;\n      }\n\n      .cls-33 {\n        fill: #e05c5c;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-37, .cls-38 {\n        fill: none;\n        stroke: #5186c7;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-38 {\n        stroke-width: 2px;\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-43 {\n        fill: #cfe1ef;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-44 {\n        fill: #345870;\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-46 {\n        fill: #5186c7;\n      }\n\n      .cls-47 {\n        fill: #69a0e1;\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-54 {\n        fill: #f5f9fd;\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-26);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 28.16,
    y1: 89.17,
    x2: 62.32,
    y2: 139.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9bc3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf4fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 324.9,
    y1: 17.73,
    x2: 343.47,
    y2: 57.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 217.57,
    y1: 24.75,
    x2: 241.1,
    y2: 133.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9bc3ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#a1c7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#b3d2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#d1e4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf4fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 173.7,
    y1: 45.53,
    x2: 221.16,
    y2: 45.53,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 173.69,
    y1: 52.33,
    x2: 221.1,
    y2: 52.33,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 173.7,
    y1: 59.13,
    x2: 221.05,
    y2: 59.13,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 173.71,
    y1: 66.56,
    x2: 191.87,
    y2: 66.56,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 235.39,
    y1: 77.55,
    x2: 282.86,
    y2: 77.55,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 235.46,
    y1: 84.35,
    x2: 282.86,
    y2: 84.35,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 235.51,
    y1: 91.15,
    x2: 282.86,
    y2: 91.15,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 264.68,
    y1: 98.58,
    x2: 282.85,
    y2: 98.58,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 309.93,
    y1: 137.59,
    x2: 398.14,
    y2: 137.59,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 282.1,
    y1: 81.6,
    x2: 400.98,
    y2: 125.33,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 279.25,
    y1: 89.35,
    x2: 398.13,
    y2: 133.08,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 276.4,
    y1: 97.1,
    x2: 395.28,
    y2: 140.83,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 273.55,
    y1: 104.85,
    x2: 392.42,
    y2: 148.58,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 270.7,
    y1: 112.6,
    x2: 389.57,
    y2: 156.33,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 267.85,
    y1: 120.36,
    x2: 386.72,
    y2: 164.09,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 330.38,
    y1: 189.49,
    x2: 349.56,
    y2: 189.49,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 330.49,
    y1: 187.36,
    x2: 349.56,
    y2: 187.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 330.41,
    y1: 195.9,
    x2: 349.56,
    y2: 195.9,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 66.15,
    y1: 107.81,
    x2: 154.35,
    y2: 107.81,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 47.34,
    y1: 100.37,
    x2: 157.44,
    y2: 63.87,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 49.97,
    y1: 108.3,
    x2: 160.07,
    y2: 71.8,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 52.6,
    y1: 116.22,
    x2: 162.7,
    y2: 79.72,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 55.23,
    y1: 124.15,
    x2: 165.32,
    y2: 87.65,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 57.86,
    y1: 132.08,
    x2: 167.95,
    y2: 95.58,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 60.49,
    y1: 140.01,
    x2: 170.58,
    y2: 103.51,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 197.04,
    y1: 120.42,
    x2: 178.95,
    y2: 126.48,
    gradientTransform: "translate(-27.69 34.94) rotate(-16.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c0035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46008d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 197.85,
    y1: 122.83,
    x2: 179.76,
    y2: 128.89,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 197.32,
    y1: 121.25,
    x2: 179.23,
    y2: 127.31,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 198.13,
    y1: 123.66,
    x2: 180.04,
    y2: 129.72,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 197.6,
    y1: 122.07,
    x2: 179.51,
    y2: 128.13,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 198.41,
    y1: 124.48,
    x2: 180.32,
    y2: 130.55,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 197.88,
    y1: 122.9,
    x2: 179.79,
    y2: 128.96,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 72.84,
    y1: 203.42,
    x2: 108.04,
    y2: 219.2,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 67.78,
    y1: 206.93,
    x2: 98.36,
    y2: 208.69,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 67.38,
    y1: 214.01,
    x2: 97.96,
    y2: 215.77,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katman_2",
    "data-name": "katman 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M72.35,109.22l-8.3-4.96-3.58,5.99c-1.69-.49-3.41-.74-5.13-.75l-1.7-6.77-9.38,2.36,1.7,6.77c-1.51,.83-2.9,1.86-4.16,3.09l-5.99-3.58-4.96,8.3,5.99,3.58c-.49,1.69-.74,3.41-.75,5.13l-6.77,1.7,2.36,9.38,6.77-1.7c.83,1.51,1.86,2.9,3.09,4.16l-3.58,5.99,8.3,4.96,3.58-5.99c1.69,.49,3.41,.74,5.13,.75l1.7,6.77,9.38-2.36-1.7-6.77c1.51-.83,2.9-1.86,4.16-3.09l5.99,3.58,4.96-8.3-5.99-3.58c.49-1.69,.74-3.41,.75-5.13l6.77-1.7-2.36-9.38-6.77,1.7c-.83-1.51-1.86-2.9-3.09-4.16l3.58-5.99Zm-13.33,12.88c3.56,2.13,4.73,6.76,2.6,10.32-2.13,3.56-6.76,4.73-10.32,2.6-3.56-2.13-4.73-6.76-2.6-10.32,2.13-3.56,6.76-4.73,10.32-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.22,27.17l-8.69-1.17-.84,6.26c-1.58,.2-3.1,.6-4.54,1.2l-3.83-5.03-6.97,5.31,3.83,5.03c-.96,1.22-1.75,2.58-2.36,4.06l-6.26-.84-1.17,8.69,6.26,.84c.2,1.58,.6,3.1,1.2,4.54l-5.03,3.83,5.31,6.97,5.03-3.83c1.22,.96,2.58,1.75,4.06,2.36l-.84,6.26,8.69,1.17,.84-6.26c1.58-.19,3.1-.6,4.54-1.2l3.83,5.03,6.97-5.31-3.83-5.03c.96-1.22,1.75-2.58,2.36-4.06l6.26,.84,1.17-8.69-6.26-.84c-.19-1.58-.6-3.1-1.2-4.54l5.03-3.83-5.31-6.97-5.03,3.83c-1.22-.96-2.59-1.76-4.06-2.36l.84-6.26Zm-6.24,13.47c4.83,.65,8.24,5.11,7.59,9.95-.65,4.84-5.11,8.24-9.95,7.59-4.83-.65-8.24-5.11-7.59-9.95,.65-4.84,5.12-8.24,9.95-7.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M165.42,38.08V109.68c16.07-2.1,33.52-3.25,51.74-3.25,27.24,0,52.73,2.56,74.56,7.03V41.85c-21.83-4.46-47.32-7.02-74.56-7.02-18.22,0-35.66,1.15-51.74,3.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M219.63,42.6c-15.32,.09-30.3,1.02-44.6,2.78-.77,.09-1.33,.75-1.33,1.52,0,.01,0,.02,0,.03,0,.91,.79,1.6,1.69,1.49,14.19-1.74,29.06-2.67,44.26-2.76,.83,0,1.5-.67,1.51-1.5,0-.01,0-.02,0-.03,0-.85-.68-1.55-1.53-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M219.56,49.41c-15.3,.09-30.25,1.03-44.53,2.78-.76,.09-1.33,.75-1.33,1.52v.03c0,.91,.79,1.61,1.7,1.5,14.17-1.74,29.01-2.67,44.19-2.76,.83,0,1.5-.67,1.51-1.5,0-.01,0-.02,0-.03,0-.85-.68-1.55-1.53-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M219.51,56.21c-15.28,.09-30.21,1.03-44.48,2.78-.76,.09-1.33,.75-1.33,1.52v.03c0,.91,.79,1.61,1.7,1.5,14.15-1.74,28.98-2.67,44.14-2.76,.83,0,1.51-.68,1.51-1.51,0-.01,0-.02,0-.03,0-.85-.69-1.54-1.53-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M190.22,64.26c-5.13,.41-10.2,.92-15.18,1.53-.76,.09-1.34,.75-1.33,1.52v.03c0,.91,.79,1.61,1.7,1.5,4.94-.61,9.97-1.11,15.07-1.52,.78-.06,1.39-.71,1.4-1.5,0-.01,0-.02,0-.03,0-.89-.76-1.61-1.65-1.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M236.93,74.62c15.32,.09,30.3,1.02,44.6,2.78,.77,.09,1.33,.75,1.33,1.52,0,.01,0,.02,0,.03,0,.91-.79,1.6-1.69,1.49-14.19-1.74-29.06-2.67-44.26-2.76-.83,0-1.5-.67-1.51-1.5,0-.01,0-.02,0-.03,0-.85,.68-1.55,1.53-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M237,81.43c15.3,.09,30.25,1.03,44.53,2.78,.76,.09,1.33,.75,1.33,1.52v.03c0,.91-.79,1.61-1.7,1.5-14.17-1.74-29.01-2.67-44.19-2.76-.83,0-1.5-.67-1.51-1.5,0-.01,0-.02,0-.03,0-.85,.68-1.55,1.53-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M237.04,88.23c15.28,.09,30.21,1.03,44.48,2.78,.76,.09,1.33,.75,1.33,1.52v.03c0,.91-.79,1.61-1.7,1.5-14.15-1.74-28.98-2.67-44.14-2.76-.83,0-1.51-.68-1.51-1.51,0-.01,0-.02,0-.03,0-.85,.69-1.54,1.53-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M266.33,96.28c5.13,.41,10.2,.92,15.18,1.53,.76,.09,1.34,.75,1.33,1.52v.03c0,.91-.79,1.61-1.7,1.5-4.94-.61-9.97-1.11-15.07-1.52-.78-.06-1.39-.71-1.4-1.5,0-.01,0-.02,0-.03,0-.89,.76-1.61,1.65-1.54Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M309.93,86.12v70.51c1.5,.14,2.97,.3,4.42,.46,5.95,.62,11.51,1.29,16.73,2.01,3.27,.44,6.4,.91,9.39,1.39,8.54,1.37,15.95,2.88,22.37,4.51,25.81,6.52,35.3,14.91,35.3,24.06V118.54c0-13.8-21.59-25.87-88.21-32.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M319.89,101.04h0c0,1.11,.85,2.05,1.96,2.16,57.56,5.86,76.29,16.47,76.29,28.57v-4.37c0-12.07-18.63-22.66-75.86-28.52-1.28-.13-2.39,.88-2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M319.89,109.84h0c0,1.11,.85,2.05,1.96,2.16,57.56,5.86,76.29,16.47,76.29,28.57v-4.37c0-12.07-18.63-22.66-75.86-28.52-1.28-.13-2.39,.88-2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M319.89,118.64h0c0,1.11,.85,2.05,1.96,2.16,57.56,5.86,76.29,16.47,76.29,28.57v-4.37c0-12.07-18.63-22.66-75.86-28.52-1.28-.13-2.39,.88-2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M319.89,127.44h0c0,1.11,.85,2.05,1.96,2.16,57.56,5.86,76.29,16.47,76.29,28.57v-4.37c0-12.07-18.63-22.66-75.86-28.52-1.28-.13-2.39,.88-2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M319.89,136.24h0c0,1.11,.85,2.05,1.96,2.16,57.56,5.86,76.29,16.47,76.29,28.57v-4.37c0-12.07-18.63-22.66-75.86-28.52-1.28-.13-2.39,.88-2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M363.26,151.88c-.02-1.38,1.28-2.39,2.61-2.06,23.61,5.82,32.26,13.36,32.26,21.58v4.37c0-8.34-8.89-15.97-33.25-21.83-.94-.23-1.61-1.05-1.62-2.02,0-.01,0-.03,0-.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M378.95,140.02v70.52c12.1-6.05,19.19-13.39,19.19-21.3V118.72c0,7.9-7.09,15.24-19.19,21.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M302.98,45.12c-.27,1.03-.6,2.07-1.01,3.13-3.67,9.67-11.33,14.72-19.6,15.95-15.33,2.32-32.74-8.41-30.73-26.96,.19-1.78,.58-3.53,1.17-5.22,2.33-6.85,7.63-12.69,14.33-15.46,3.47-1.43,7.09-2.11,10.65-2.12,15.58-.03,30.01,12.64,25.19,30.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M277.79,14.45c-.07,.21-.13,.41-.18,.62-.55,2.17-.45,4.37,.4,6.44,.75,1.84,2.11,3.33,3.16,5,.62,.97,1.45,2.48,.65,3.55-.74,.99-2.53,1.8-3.52,2.84-2.87,3-2.72,7.54-.32,10.76,2.63,3.54,7.35,4.36,11.49,3.91,4.02-.43,7.78-2.39,11.84-2.55,.54-.02,1.11,0,1.68,.1,4.83-18.03-9.61-30.71-25.19-30.67Zm-1.05,39.22c-1.3-.69-2.65-1.28-3.97-1.93-.49-.24-.8-.4-1.38-.77-.23-.14-.46-.3-.67-.46-.11-.08-.49-.42-.54-.45h0c-.71-.74-1.07-1.37-1.04-2.59,.05-1.46,.71-2.87,1.24-4.2,1.19-2.94,2.41-6.25,.93-9.34-1.48-3.09-4.99-4.5-8.27-4.48-3.63,.02-6.79,1.77-10.23,2.57-.59,1.68-.98,3.44-1.17,5.22-2,18.55,15.41,29.28,30.73,26.96,.17-1.29,.25-2.6-.01-3.88-.62-3.11-2.9-5.23-5.62-6.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M303.26,43.99c-.09,.38-.18,.75-.28,1.14-.27,1.03-.6,2.07-1.01,3.13-3.67,9.67-11.33,14.72-19.6,15.95-15.33,2.32-32.74-8.41-30.73-26.96,.19-1.78,.58-3.53,1.17-5.22,.62-1.81,1.45-3.56,2.46-5.19-.12,.61-.21,1.22-.28,1.84-2,18.55,15.41,29.28,30.74,26.96,6.94-1.04,13.45-4.76,17.53-11.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M317.03,21.47c-.33,1.55-1.34,2.87-2.29,4.11-3.08,4.05-6.82,7.52-10.89,10.56-3.99,2.98-8.28,5.54-12.62,7.87-9.96,5.33-20.39,9.85-31.06,13.57-.2,.07-.39,.14-.59,.2-2.4,.83-4.8,1.62-7.23,2.36-2.76,.85-5.72,2.04-8.64,1.83-2.52-.19-4.99-1.88-5.46-4.47-.48-2.65,1.26-4.88,3.02-6.63,3.2-3.17,6.62-6.12,10.29-8.75,.1,1.2,.28,2.37,.53,3.49-3.1,2.59-6.1,5.38-8.7,8.44-.98,1.15-2.16,3.02-.12,3.75,1.98,.72,4.61-.54,6.51-1.11,2.23-.68,4.45-1.4,6.65-2.15,2.6-.88,5.19-1.82,7.76-2.79,9.15-3.5,18.16-7.52,26.69-12.34,4.19-2.37,8.27-5.02,11.98-8.1,3.05-2.52,5.84-5.34,8.26-8.52,.54-.72,1.05-1.43,1.39-2.23t-.02,0c-.23-.03-.4-.12-.74-.16-2.11-.2-4.71,.38-6.88,.75-2.4,.4-4.8,.91-7.17,1.53-1.19-1.27-2.53-2.4-3.98-3.39,4.54-1.62,9.22-2.72,14.05-3.25,2.55-.29,5.69-.76,7.82,1.04,1.27,1.07,1.77,2.78,1.43,4.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M283.09,6.03c.73,1.8,2.83,3.08,4.91,2.95,2.08-.13,3.93-1.69,4.21-3.58,.33-2.26-2.07-5.5-4.74-5.4-3.24,.12-5.52,3.2-4.38,6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M252.41,82.7c2.5,1.89,6.16,2.07,8.83,.45,6.48-3.94,3.44-14-3.8-14.55-7.52-.57-10.95,9.64-5.03,14.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "354.02 75.66 372.84 81.75 368.73 62.3 349.83 56.13 354.02 75.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "372.84 81.75 387.59 68.57 383.41 49.04 368.73 62.3 372.84 81.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "349.83 56.13 368.73 62.3 383.41 49.04 364.51 42.87 349.83 56.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 385.45,
    y1: 86.13,
    x2: 385.45,
    y2: 65.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 385.45,
    y1: 88.31,
    x2: 385.45,
    y2: 91.34
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 380.37,
    y1: 81.94,
    x2: 380.37,
    y2: 71.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M330.38,191.74v-25.79c12.1,6.05,19.19,13.39,19.19,21.3v25.79c0-7.9-7.09-15.24-19.19-21.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M314.27,211.48c-4.75,1.2-10.05,2.34-15.94,3.41,.03,8.59,.05,17.19,.08,25.78,37.88-6.87,51.16-16.63,51.16-27.45v-25.79c0,9.15-9.49,17.54-35.3,24.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.93,178.73v.06c.01,.68,.37,1.31,.94,1.68,8.09,5.25,12.69,11.24,12.69,17.6v-5.01c0-5.73-3.73-11.15-10.37-16.01-1.36-1-3.28,0-3.26,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M336,187.28s0,.03,0,.05c0,.69,.37,1.32,.94,1.7,8.05,5.24,12.62,11.21,12.62,17.55v-5.01c0-5.7-3.7-11.11-10.3-15.95-1.36-.99-3.27-.02-3.26,1.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M338.7,182.48s14.46-10.5,33.83-18.99l-29.85-44.42-26.86,23.98s-22.81,11.81-41.72,4.97l-2.12,6.76,28.6,41.45s22.95-.32,38.12-13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M314.51,140.74l21.97,38.94s-17.04,14.09-34.92,10.39l-26.82-44.09c24.37,5.33,24.66-13.26,39.77-5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M314.51,140.74c-1.05-12.51,21.97-25.2,21.97-25.2l29.79,45.2s-17.94,.82-29.79,18.95l-21.97-38.94Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 314.51,
    y1: 140.74,
    x2: 336.48,
    y2: 179.68
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M298.39,154.52c-1.07-2-2.1-4.03-3.36-5.91-.14-.21-.44-.41-.71-.3-2.53,1.02-5.19,1.67-7.8,2.48-.27-.06-.57,.07-.75,.29-.39,.34-.27,1.01,.14,1.21,.62,1.2,1.24,2.39,1.85,3.59,.33,.65,.66,1.31,1.02,1.94,.29,.51,.69,.99,1.28,1.13,.63,.14,1.31-.15,1.88-.4,.68-.3,1.34-.63,2.01-.96,1.37-.67,2.74-1.32,4.12-1.96,.4-.19,.49-.74,.3-1.09Zm-4.55,1.48c-.56,.28-1.12,.57-1.69,.85-.3,.15-.59,.31-.89,.46-.2,.11-.51,.34-.74,.29-.41-.07-.64-.86-.8-1.17-.29-.57-.59-1.14-.89-1.71-.48-.93-.97-1.85-1.45-2.78,2.24-.79,4.45-1.66,6.74-2.28,.73,1.67,1.6,3.29,2.47,4.9-.92,.48-1.83,.96-2.76,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M310.91,142.35c-4.29-1.37-7.5,2.95-11.3,3.9-.68,.17-.4,1.2,.28,1.05,1.89-.4,3.49-1.48,5.16-2.4,1.69-.94,3.54-1.65,5.46-.99,.98,.34,1.41-1.25,.41-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M312.16,146.43c-.88-.09-1.83,.05-2.7,.17-.9,.13-1.79,.36-2.65,.67-1.72,.63-3.29,1.56-4.65,2.8-.63,.57,.29,1.47,.93,.93,1.24-1.04,2.7-1.84,4.24-2.33,.76-.24,1.54-.42,2.32-.51,.85-.1,1.65-.03,2.5,0,.46,.01,.86-.4,.86-.86,0-.5-.4-.81-.86-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M315.18,152.14c-8.41,.82-14.61,7.34-22.63,9.31-.83,.2-.49,1.45,.34,1.28,3.99-.82,7.56-2.78,11.13-4.67,3.5-1.86,7.15-3.73,11.17-4.06,1.2-.1,1.19-1.98,0-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M302.88,162.15c-.67,.16-1.27,.51-1.9,.78-.55,.24-1.11,.45-1.68,.64-1.21,.39-2.47,.68-3.73,.83-.36,.04-.68,.28-.68,.68,0,.36,.31,.69,.68,.68,1.4-.06,2.78-.28,4.12-.68,.66-.2,1.31-.43,1.95-.71,.67-.29,1.35-.59,1.86-1.12,.46-.47,0-1.25-.63-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M326.01,168.37c-1.01-3.44-3.37-7.62-7.49-7.44-2.38,.1-4.45,1.48-6.38,2.75-2.01,1.32-4.08,2.53-6.22,3.62-2.46,1.24-4.98,2.39-7.55,3.38-.39,.15-.48,.55-.37,.85-.58-.02-1.13,.52-.77,1.2,.99,1.82,2.19,3.53,3.29,5.28,.25,.39,.76,.57,1.17,.32,3.61-2.14,7.4-3.98,11.34-5.47,1.96-.74,3.95-1.39,5.97-1.96,2.01-.57,4.08-1.14,6.15-1.4,.54-.07,1.03-.51,.86-1.11Zm-7.43,.91c-2.06,.58-4.09,1.24-6.09,1.99-3.77,1.42-7.42,3.15-10.92,5.14-.93-1.53-1.85-3.08-2.89-4.53-.01-.01-.03-.02-.04-.03,0,0,.02,0,.03,0,4.28-1.26,8.35-3.04,12.2-5.3,2.98-1.74,7.47-5.83,10.77-2.56,1.12,1.11,1.72,2.55,2.3,3.98-1.79,.43-3.59,.81-5.36,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M324.82,171.07c-1.82,.51-3.59,1.31-5.37,1.96-1.79,.65-3.58,1.31-5.37,1.96-3.58,1.31-7.15,2.66-10.7,4.04-.84,.33-.52,1.68,.36,1.38,3.64-1.26,7.27-2.54,10.89-3.87,1.79-.66,3.58-1.31,5.36-1.97,1.8-.66,3.69-1.21,5.43-2,.85-.39,.27-1.75-.61-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M314.35,179.33c-.45-.04-.88,.21-1.26,.41-.32,.16-.65,.32-.97,.46-.66,.3-1.33,.57-2.01,.81-1.43,.51-2.9,.9-4.39,1.16-.4,.07-.63,.55-.53,.91,.11,.43,.51,.59,.91,.53,1.56-.22,3.09-.56,4.58-1.04,.76-.24,1.5-.52,2.23-.83,.7-.29,1.71-.59,2.11-1.29,.3-.53-.11-1.09-.66-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M333.4,123.65c-.87,.02-1.8,.64-2.56,1.04-.77,.4-1.51,.84-2.24,1.31-1.54,.99-3,2.13-4.35,3.38-2.66,2.48-4.85,5.45-6.45,8.72-.39,.79,.79,1.47,1.2,.68,1.59-3.09,3.72-5.86,6.28-8.21,1.27-1.17,2.65-2.23,4.11-3.16,.7-.44,1.42-.86,2.16-1.24,.75-.39,1.76-.66,2.37-1.25,.45-.44,.12-1.28-.52-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M325.56,134.96c-.17-.17-.49-.24-.7-.1-.54,.37-.94,.83-1.36,1.32-.41,.49-.81,.99-1.21,1.49-.79,.98-1.58,1.96-2.37,2.95-.23,.28-.27,.67,0,.94,.24,.24,.71,.27,.94,0,.82-.95,1.64-1.9,2.46-2.86,.4-.47,.81-.93,1.21-1.41,.42-.52,.86-1.01,1.13-1.63,.11-.24,.1-.51-.1-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M345.68,137.54c-1.05-1.87-2.28-3.92-4.34-4.8-2.35-1-4.8-.03-6.89,1.13-2.13,1.18-4.13,2.59-5.99,4.15-1.88,1.59-3.72,3.41-5.09,5.48-.03,.05-.04,.1-.06,.15-.6-.02-1.2,.66-.81,1.27,1.29,1.99,2.9,3.81,4.35,5.69,.3,.39,.91,.27,1.23,0,5.35-4.53,11.14-8.52,17.27-11.92,.4-.22,.54-.75,.32-1.15Zm-21.48,6.77s.09-.05,.12-.08c1.55-1.58,3.02-3.19,4.7-4.64,1.65-1.42,3.42-2.68,5.3-3.78,1.77-1.04,4.1-2.47,6.22-1.65,1.52,.59,2.48,2.07,3.27,3.48-5.72,3.21-11.13,6.94-16.19,11.12-1.12-1.5-2.21-3.04-3.43-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M347.21,140.86c-.58-.26-1.05,.02-1.6,.25-.48,.2-.95,.42-1.41,.66-.95,.48-1.86,1.03-2.74,1.64-1.74,1.22-3.29,2.66-4.63,4.32-.51,.64,.36,1.55,.92,.92,1.31-1.49,2.81-2.83,4.45-3.94,.82-.55,1.67-1.05,2.55-1.5,.44-.22,.89-.43,1.34-.62,.48-.2,1.13-.3,1.37-.81,.15-.31,.1-.77-.26-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M349.47,144.37c-.18-.23-.44-.3-.72-.25-.23,.03-.43,.19-.62,.31-.15,.09-.29,.18-.44,.27-.3,.19-.6,.38-.9,.58-.61,.39-1.22,.78-1.81,1.21-.25,.18-.41,.52-.22,.81,.18,.28,.51,.38,.81,.22,.66-.33,1.29-.7,1.93-1.07,.32-.18,.64-.36,.96-.55,.15-.09,.29-.18,.44-.26,.08-.05,.17-.1,.25-.15,.16-.1,.26-.21,.37-.36,.16-.22,.09-.56-.06-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M350.78,148.77c-.85,.03-1.75,.53-2.53,.87-.77,.33-1.54,.68-2.29,1.06-1.6,.81-3.15,1.72-4.63,2.74-2.93,2.01-5.55,4.42-7.83,7.14-.53,.63,.36,1.55,.92,.92,2.26-2.56,4.84-4.81,7.67-6.72,1.39-.94,2.85-1.79,4.35-2.55,.75-.38,1.51-.73,2.29-1.06,.76-.32,1.77-.51,2.43-1.01,.54-.41,.45-1.41-.37-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M335.69,150.82c-.89-1.12-2.4-1.55-3.75-1.06-1.64,.59-2.6,2.12-2.94,3.77-.06,.27,.05,.48,.22,.6,.47,1.41,1.72,2.36,3.19,2.53,1.43,.17,2.81-.59,3.57-1.79,.81-1.28,.63-2.89-.29-4.05Zm-.93,2.21s0,.07,0,.1c0,.03-.02,.09-.02,.1-.01,.06-.03,.11-.04,.16-.02,.05-.03,.11-.05,.16,0,.02,0,.02,0,.02,0,0,0,.01-.02,.04-.06,.11-.12,.22-.19,.33,0,.01-.04,.05-.06,.08-.02,.02-.05,.05-.05,.06-.08,.08-.16,.16-.24,.24,0,0-.04,.03-.07,.05-.04,.03-.13,.09-.14,.1-.1,.06-.19,.12-.3,.17-.01,0-.05,.02-.08,.04-.03,.01-.07,.03-.09,.03-.11,.03-.22,.06-.33,.08-.01,0,0,0-.02,0-.09,0-.17,.01-.26,.01-.06,0-.12,0-.17,0-.02,0-.02,0-.02,0-.01,0-.01,0-.04,0-.14-.03-.28-.07-.42-.11-.01,0-.04-.01-.06-.02-.07-.03-.13-.06-.19-.09-.11-.06-.23-.13-.34-.2,0,0-.04-.03-.07-.05-.03-.03-.1-.08-.11-.09-.11-.1-.21-.2-.3-.31-.04-.04-.08-.09-.11-.13,0,0-.07-.1-.09-.12-.07-.11-.14-.22-.2-.34-.06-.13-.15-.21-.25-.28,.31-.7,.77-1.33,1.45-1.7,.42-.22,.9-.35,1.37-.28,.05,0,.17,.04,.25,.06,.16,.05,.11,.03,.24,.1,.24,.13,.26,.14,.47,.35,.04,.04,.08,.08,.12,.12,.02,.02,.03,.03,.04,.04,0,0,0,0,.01,.02,.07,.09,.12,.19,.18,.29,.03,.05,.05,.1,.08,.15,0,.02,0,.01,.01,.02,0,0,0,0,0,.01,.04,.12,.08,.24,.11,.37,0-.01,.02,.11,.02,.15,0,.03,0,.08,0,.09,0,.06,0,.11,0,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M340.74,159.85c-.2-.26-.66-.43-.96-.2-1.39,1.04-2.64,2.26-3.93,3.42-.27,.25-.27,.75,0,1,.3,.28,.69,.25,1,0,.65-.53,1.29-1.06,1.94-1.6,.65-.53,1.3-1.06,1.89-1.64,.27-.26,.28-.69,.06-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M355.07,155c-1.62,.53-3.2,1.34-4.7,2.13-1.56,.82-3.07,1.73-4.53,2.73-2.87,1.97-5.49,4.3-7.82,6.89-.57,.63,.34,1.56,.94,.94,2.37-2.42,4.99-4.56,7.8-6.44,1.37-.91,2.79-1.75,4.25-2.51,1.54-.8,3.14-1.42,4.71-2.13,.9-.41,.28-1.92-.65-1.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M154.35,56.34V126.85c-1.5,.14-2.97,.3-4.42,.46-5.95,.62-11.51,1.29-16.73,2.01-3.27,.44-6.4,.91-9.39,1.39-8.54,1.37-15.95,2.88-22.37,4.51-25.81,6.52-35.3,14.91-35.3,24.06V88.77c0-13.8,21.59-25.87,88.21-32.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M144.39,71.26h0c0,1.11-.85,2.05-1.96,2.16-57.56,5.86-76.29,16.47-76.29,28.57v-4.37c0-12.07,18.63-22.66,75.86-28.52,1.28-.13,2.39,.88,2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M144.39,80.06h0c0,1.11-.85,2.05-1.96,2.16-57.56,5.86-76.29,16.47-76.29,28.57v-4.37c0-12.07,18.63-22.66,75.86-28.52,1.28-.13,2.39,.88,2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M144.39,88.86h0c0,1.11-.85,2.05-1.96,2.16-57.56,5.86-76.29,16.47-76.29,28.57v-4.37c0-12.07,18.63-22.66,75.86-28.52,1.28-.13,2.39,.88,2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M144.39,97.66h0c0,1.11-.85,2.05-1.96,2.16-57.56,5.86-76.29,16.47-76.29,28.57v-4.37c0-12.07,18.63-22.66,75.86-28.52,1.28-.13,2.39,.88,2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M144.39,106.46h0c0,1.11-.85,2.05-1.96,2.16-57.56,5.86-76.29,16.47-76.29,28.57v-4.37c0-12.07,18.63-22.66,75.86-28.52,1.28-.13,2.39,.88,2.39,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M101.02,122.1c.02-1.38-1.28-2.39-2.61-2.06-23.61,5.82-32.26,13.36-32.26,21.58v4.37c0-8.34,8.89-15.97,33.25-21.83,.94-.23,1.61-1.05,1.62-2.02,0-.01,0-.03,0-.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M85.33,110.24v70.52c-12.1-6.05-19.19-13.39-19.19-21.3V88.94c0,7.9,7.09,15.24,19.19,21.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 202.26,
    cy: 107.3,
    r: 11.14,
    transform: "translate(17.29 242.23) rotate(-64.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M188.85,111.32c1.77,5.89-1.57,12.1-7.46,13.87-5.89,1.77-12.1-1.57-13.87-7.46-1.77-5.89,1.57-12.1,7.46-13.87,5.89-1.77,12.1,1.57,13.87,7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M157.07,85.11h61.48c6.79,0,12.3,5.51,12.3,12.3v6.33c0,7.06-5.73,12.79-12.79,12.79h-60.5c-7.06,0-12.79-5.73-12.79-12.79v-6.33c0-6.79,5.51-12.3,12.3-12.3Z",
    transform: "translate(-21.07 58.29) rotate(-16.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 143.17,
    y: 80.69,
    width: 86.09,
    height: 29.57,
    rx: 11.81,
    ry: 11.81,
    transform: "translate(-19.59 57.6) rotate(-16.72)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M185.78,109.02c1.3,4.33-1.16,8.89-5.49,10.2-4.33,1.3-8.89-1.16-10.2-5.49-1.3-4.33,1.16-8.89,5.49-10.2,4.33-1.3,8.89,1.16,10.19,5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M208.23,102.27c1.3,4.33-1.16,8.89-5.49,10.2-4.33,1.3-8.89-1.16-10.2-5.49s1.16-8.89,5.49-10.2c4.33-1.3,8.89,1.16,10.2,5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M205.44,102.71c.83,2.75-.73,5.66-3.49,6.48-2.75,.83-5.66-.73-6.48-3.49-.83-2.75,.73-5.66,3.49-6.48,2.75-.83,5.66,.74,6.48,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M183.04,109.44c.83,2.75-.73,5.66-3.49,6.48-2.75,.83-5.66-.73-6.48-3.49-.83-2.75,.73-5.66,3.49-6.48,2.75-.83,5.66,.73,6.48,3.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M170.41,105.25c-.91,6.22-6.69,10.53-12.91,9.62-6.22-.91-10.53-6.69-9.62-12.91,.91-6.22,6.69-10.53,12.91-9.62,6.22,.91,10.53,6.69,9.62,12.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M224.71,88.94c-.91,6.22-6.69,10.53-12.91,9.62-6.22-.91-10.53-6.69-9.62-12.91,.91-6.22,6.69-10.53,12.91-9.62,6.22,.91,10.53,6.69,9.62,12.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 170.26,
    y: 80.43,
    width: 27.79,
    height: 18.32,
    rx: 2.8,
    ry: 2.8,
    transform: "translate(-17.99 56.76) rotate(-16.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 169.67,
    y: 78.66,
    width: 27.79,
    height: 17.92,
    rx: 3.05,
    ry: 3.05,
    transform: "translate(-17.45 56.51) rotate(-16.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M192.22,79.94l2.58,8.59c.34,1.15-.3,2.36-1.46,2.71l-15.71,4.72c-.37,.11-.75,.12-1.1,.03-.74-.16-1.37-.71-1.61-1.49l-2.58-8.59c-.19-.64,.17-1.32,.81-1.51l17.55-5.27c.64-.19,1.32,.17,1.51,.81Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "189.16 79.6 185.54 93.58 178.02 95.84 181.64 81.86 189.16 79.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M180.07,82.33l-3.54,13.66c-.74-.16-1.37-.71-1.61-1.49l-1.05-3.49,1.91-7.4,4.28-1.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "192.51 80.91 193.73 84.97 192 91.64 189.54 92.38 192.51 80.91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M184.59,101.7c.12,.41-.11,.85-.53,.98-.41,.12-.85-.11-.98-.53-.12-.41,.11-.85,.53-.98,.41-.12,.85,.11,.98,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M186.54,103.43c.12,.41-.11,.85-.53,.98-.41,.12-.85-.11-.98-.53-.12-.41,.11-.85,.53-.98s.85,.11,.98,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M187.22,100.91c.12,.41-.11,.85-.53,.98-.41,.12-.85-.11-.98-.53s.11-.85,.53-.98c.41-.12,.85,.11,.98,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M189.18,102.64c.12,.41-.11,.85-.53,.98-.41,.12-.85-.11-.98-.53-.12-.41,.11-.85,.53-.98,.41-.12,.85,.11,.98,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M189.86,100.12c.12,.41-.11,.85-.53,.98-.41,.12-.85-.11-.98-.53-.12-.41,.11-.85,.53-.98,.41-.12,.85,.11,.98,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M191.81,101.85c.12,.41-.11,.85-.53,.98-.41,.12-.85-.11-.98-.53-.12-.41,.11-.85,.53-.98,.41-.12,.85,.11,.98,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M192.49,99.33c.12,.41-.11,.85-.53,.98-.41,.12-.85-.11-.98-.53-.12-.41,.11-.85,.53-.98,.41-.12,.85,.11,.98,.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M159.98,99.47l-1.11,1.34c-.15,.19-.38,.26-.61,.18l-1.66-.51c-.25-.08-.46-.31-.55-.61l-.72-2.41c-.13-.44,.05-.89,.41-1l2.77-.83c.36-.11,.76,.17,.89,.61l.72,2.41c.09,.3,.04,.61-.13,.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M158.43,106.58l1.11-1.34c.15-.19,.38-.26,.61-.18l1.66,.51c.25,.08,.46,.31,.55,.61l.72,2.41c.13,.44-.05,.89-.41,1l-2.77,.83c-.36,.11-.76-.17-.89-.61l-.72-2.41c-.09-.3-.04-.61,.13-.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M155.25,102.85l1.28,.89c.18,.12,.24,.32,.16,.52l-.58,1.45c-.09,.22-.33,.41-.62,.5l-2.41,.72c-.44,.13-.88,0-.97-.31l-.7-2.35c-.09-.3,.2-.66,.64-.79l2.41-.72c.3-.09,.6-.06,.8,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M163.27,103.56l-1.28-.89c-.18-.12-.24-.32-.16-.52l.58-1.45c.09-.22,.33-.41,.62-.5l2.41-.72c.44-.13,.88,0,.97,.31l.7,2.35c.09,.3-.2,.66-.64,.79l-2.41,.72c-.3,.09-.6,.06-.8-.08Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M166.47,92.34h0c-.8,.24-1.64-.21-1.88-1.01l-.29-.98c-.24-.8,.21-1.64,1.01-1.88h0c.8-.24,1.64,.21,1.88,1.01l.29,.98c.24,.8-.21,1.64-1.01,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M167.18,89.48c.24,.8-.21,1.64-1.01,1.88-.8,.24-1.64-.21-1.88-1.01-.24-.8,.21-1.64,1.01-1.88,.8-.24,1.64,.21,1.88,1.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M200.95,81.98h0c-.8,.24-1.64-.21-1.88-1.01l-.29-.98c-.24-.8,.21-1.64,1.01-1.88h0c.8-.24,1.64,.21,1.88,1.01l.29,.98c.24,.8-.21,1.64-1.01,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M201.67,79.12c.24,.8-.21,1.64-1.01,1.88-.8,.24-1.64-.21-1.88-1.01-.24-.8,.21-1.64,1.01-1.88,.8-.24,1.64,.21,1.88,1.01Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 211.71,
    cy: 81.54,
    r: 2.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 215.17,
    cy: 93.05,
    r: 2.73,
    transform: "translate(31.81 239.12) rotate(-61.93)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M210.3,88.24c.43,1.45-.39,2.97-1.83,3.41-1.45,.43-2.97-.39-3.41-1.83s.39-2.97,1.83-3.41c1.45-.43,2.97,.39,3.41,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M221.82,84.78c.43,1.45-.39,2.97-1.83,3.41-1.45,.43-2.97-.39-3.41-1.83-.43-1.45,.39-2.97,1.83-3.41,1.45-.43,2.97,.39,3.41,1.83Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 206.71,
    y: 88.05,
    width: 1.95,
    height: 1.95,
    transform: "translate(-16.83 63.5) rotate(-16.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 210.74,
    y: 80.57,
    width: 1.95,
    height: 1.95,
    transform: "translate(-14.51 64.34) rotate(-16.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 214.22,
    y: 92.14,
    width: 1.95,
    height: 1.95,
    transform: "translate(-17.69 65.83) rotate(-16.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 218.24,
    y: 84.65,
    width: 1.95,
    height: 1.95,
    transform: "translate(-15.36 66.68) rotate(-16.72)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M224.53,84.69c-1.39-3.8-4.77-6.74-9.05-7.36-6.22-.91-12,3.4-12.91,9.63-.21,1.46-.14,2.89,.18,4.25-.63-1.72-.85-3.61-.57-5.55,.91-6.23,6.69-10.53,12.91-9.63,4.76,.69,8.4,4.24,9.44,8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M170.23,101c-1.39-3.8-4.77-6.74-9.05-7.36-6.22-.91-12,3.4-12.91,9.63-.21,1.46-.14,2.89,.18,4.25-.63-1.72-.85-3.61-.57-5.55,.91-6.23,6.69-10.53,12.91-9.63,4.76,.69,8.4,4.24,9.44,8.66Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M180.45,170.16v46.55c0,2.87-1.85,5.59-4.16,6.08l-71.45,15.29c-3.74,.8-6.84-1.57-6.84-5.31v-60.75c0-3.74,3.09-6.79,6.84-6.8l71.45-.25c2.31,0,4.16,2.31,4.16,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M180.45,170.16v.65l-82.45,2.07v-.84c0-3.74,3.09-6.79,6.84-6.8l71.45-.25c2.31,0,4.16,2.31,4.16,5.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M108.8,168.91c0,1.1-.89,2.01-2,2.04-1.12,.02-2.03-.86-2.03-1.98s.91-2.03,2.03-2.04c1.11,0,2,.88,2,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M115.66,168.81c0,1.08-.86,1.97-1.92,2-1.07,.02-1.95-.85-1.95-1.94s.87-1.99,1.95-2c1.07,0,1.92,.86,1.92,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M122.25,168.72c0,1.06-.83,1.93-1.85,1.96-1.03,.02-1.87-.83-1.87-1.9s.84-1.95,1.87-1.96c1.02,0,1.85,.84,1.85,1.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M139.98,187.07l12.65,6.67c1.19,.62,1.19,2.58,0,3.46l-12.65,9.33c-1.24,.92-2.78,.13-2.78-1.44v-15.99c0-1.57,1.53-2.68,2.78-2.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M175.99,222.86l-70.66,15.12c-4.01,.86-7.32-1.69-7.32-5.7v-5.17l82.45-14.74v3.96c0,3.08-1.98,5.99-4.46,6.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M152.17,223.32c0-.56-.01-1.13-.05-1.69l-37.68,7.4c-.57,.11-.94,.67-.83,1.24,.1,.5,.54,.85,1.03,.85,.07,0,.14,0,.2-.02l37.31-7.33c0-.15,.01-.3,.01-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M176.25,216.89l-22.71,4.46c.09,.58,.15,1.17,.2,1.76,.01,.11,.02,.23,.02,.35l22.89-4.5c.57-.11,.94-.67,.83-1.24-.11-.57-.67-.94-1.24-.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M104.43,233.12c-.49,0-.93-.35-1.03-.85-.11-.57,.26-1.13,.83-1.24l18.91-3.71c.57-.11,1.13,.26,1.24,.83,.11,.57-.26,1.13-.83,1.24l-18.91,3.71c-.07,.01-.14,.02-.2,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M155.57,221.99c0,2.07-1.59,4.08-3.58,4.49-2.01,.42-3.66-.95-3.66-3.07s1.65-4.14,3.66-4.51c1.99-.37,3.58,1.02,3.58,3.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M153.76,222.35c0,1.03-.79,2.02-1.77,2.22-.99,.2-1.79-.48-1.79-1.52s.81-2.03,1.79-2.22c.98-.19,1.77,.49,1.77,1.52Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.39,208.56s0,.04,0,.06l.8,26.7c-.24-8.04,12.75-15.74,34.12-21.77l-.8-26.76c-21.38,6.03-34.37,13.73-34.13,21.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.02,198.18c-13.92,4.73-23,10.26-25.33,16.06,.04,1.2,.08,2.4,.11,3.6,2.59-5.86,12.04-11.42,26.39-16.16,.78-.26,1.3-.99,1.28-1.81h0c-.04-1.24-1.27-2.09-2.45-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.02,205.4c-13.59,4.62-22.55,9.99-25.14,15.64,0,1.26,0,2.53,0,3.79,2.73-5.78,12.13-11.26,26.3-15.94,.78-.26,1.3-.99,1.28-1.81h0c-.04-1.24-1.27-2.09-2.45-1.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M72.35,207.2l.8,26.76c.41,13.67,39.03,24.06,91.56,26.16l-.8-26.77c-52.53-2.09-91.15-12.48-91.56-26.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M248.67,131.4c-1.96,0-3.83-.71-5.31-2.01l2.79-3.16c.76,.67,1.73,1.02,2.76,.95,1.02-.06,1.95-.52,2.62-1.28,.68-.76,1.01-1.74,.95-2.76-.06-1.02-.52-1.95-1.28-2.62l2.79-3.16c1.61,1.42,2.56,3.38,2.69,5.52,.13,2.14-.58,4.2-2,5.81-1.42,1.61-3.38,2.56-5.52,2.69-.17,.01-.33,.02-.5,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M422.31,131.46c-1.05,0-2.1-.21-3.09-.63-1.98-.83-3.52-2.37-4.33-4.36-.81-1.98-.81-4.17,.02-6.14,.83-1.98,2.37-3.52,4.36-4.33l1.6,3.9c-.94,.39-1.68,1.12-2.07,2.06s-.4,1.98,0,2.92c.39,.94,1.12,1.68,2.06,2.07,.94,.39,1.98,.39,2.92,0l1.6,3.9c-.98,.4-2.02,.61-3.05,.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M120.37,40.73c-1.05,0-2.1-.21-3.09-.63-1.98-.83-3.52-2.37-4.33-4.36-1.68-4.1,.28-8.8,4.38-10.48l1.6,3.9c-1.94,.8-2.88,3.03-2.08,4.98,.8,1.94,3.03,2.88,4.97,2.08l1.6,3.9c-.98,.4-2.02,.61-3.05,.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M5.87,162.32c-2.15,0-4.29-.85-5.87-2.54l3.08-2.88c1.43,1.54,3.85,1.62,5.39,.18,1.54-1.43,1.62-3.85,.18-5.39l3.08-2.88c3.02,3.24,2.85,8.33-.39,11.35-1.55,1.44-3.51,2.16-5.48,2.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M142.8,144.4c-4.72,0-4.72,7.32,0,7.32s4.72-7.32,0-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M413.24,83.63c-4.72,0-4.72,7.32,0,7.32s4.72-7.32,0-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M323.51,254.93c-4.72,0-4.72,7.32,0,7.32s4.72-7.32,0-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M62.09,57.22c-4.72,0-4.72,7.32,0,7.32s4.72-7.32,0-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M227.57,15.67c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M209.31,144.24c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M292.82,127.15c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M312.25,67.72c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M381,21.5c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M366.63,189.3c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M287.39,204.06c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M157.65,270.48c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M66.76,185.8c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M13.54,112c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M148.71,34.31c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M412.85,153.95c-2.7,0-2.7,4.18,0,4.18s2.7-4.18,0-4.18Z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr1);
export default __webpack_public_path__ + "static/media/vr1.60f61ed39c73fcb5fcefb2579b965510.svg";
export { ForwardRef as ReactComponent };